(function(){
  var d=document;
  var drawer=d.querySelector('.drawer');
  d.querySelectorAll('[data-open-drawer]').forEach(function(b){b.addEventListener('click',function(){drawer&&drawer.classList.add('open')})});
  d.querySelectorAll('[data-close-drawer]').forEach(function(b){b.addEventListener('click',function(){drawer&&drawer.classList.remove('open')})});
  var sb=d.querySelector('.search-bar');
  d.querySelectorAll('[data-toggle-search]').forEach(function(b){b.addEventListener('click',function(){
    if(!sb)return;sb.classList.toggle('open');var i=sb.querySelector('input');if(sb.classList.contains('open')&&i)i.focus();
  })});
  // sort
  var sort=d.querySelector('[data-sort]');
  if(sort){sort.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',sort.value);u.searchParams.delete('page');location.href=u.toString()})}
  // quantity buttons
  d.querySelectorAll('.qty').forEach(function(q){
    var i=q.querySelector('input');
    q.querySelectorAll('button').forEach(function(b){b.addEventListener('click',function(e){
      e.preventDefault();var v=parseInt(i.value||'1',10)+(b.dataset.step==='up'?1:-1);i.value=Math.max(i.min===''?1:parseInt(i.min,10),v);
      if(q.hasAttribute('data-autosubmit'))q.closest('form').submit();
    })});
  });
  // product page
  var pdp=d.querySelector('[data-product]');
  if(pdp){
    var data=JSON.parse(d.querySelector('[data-product-json]').textContent);
    var form=pdp.querySelector('form[data-product-form]');
    var idInput=form.querySelector('[name=id]');
    var priceEl=pdp.querySelector('[data-price]');
    var btn=form.querySelector('[data-add]');
    var money=function(c){return (c/100).toLocaleString(undefined,{style:'currency',currency:data.currency})};
    var update=function(){
      var sel=[].map.call(form.querySelectorAll('[data-option]'),function(s){return s.value});
      var v=data.variants.find(function(x){return x.options.every(function(o,i){return o===sel[i]})});
      if(!v){btn.disabled=true;btn.textContent=data.t.unavailable;return}
      idInput.value=v.id;
      priceEl.innerHTML=v.compare_at_price>v.price?'<span class="sale">'+money(v.price)+'</span><s>'+money(v.compare_at_price)+'</s>':money(v.price);
      btn.disabled=!v.available;btn.textContent=v.available?data.t.add:data.t.sold;
      var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);
      if(v.featured_media_id){var t=pdp.querySelector('[data-media="'+v.featured_media_id+'"]');t&&t.click()}
    };
    form.querySelectorAll('[data-option]').forEach(function(s){s.addEventListener('change',update)});
    var main=pdp.querySelector('[data-main]');
    pdp.querySelectorAll('[data-thumb]').forEach(function(t){t.addEventListener('click',function(){
      main.src=t.dataset.src;main.srcset='';pdp.querySelectorAll('[data-thumb]').forEach(function(x){x.classList.remove('on')});t.classList.add('on');
    })});
  }
})();
